/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, signal } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DragHandleComponent } from 'src/app/shared/drag-handle/drag-handle.component';
import { StampProfile } from '../interfaces/stamp-profile.interface';
import { PassportService } from '../service/passport.service';
import { MapStampComponent } from '../map-stamp/map-stamp.component';
import { ToolsService } from 'src/app/services/tools.service';
import { combineLatest, filter, take } from 'rxjs';

@Component({
  selector: "app-passport-add-stamp",
  imports: [
    CommonModule,
    TranslateModule,
    DragHandleComponent,
    MapStampComponent
  ],  
  standalone: true,
  templateUrl: "./my-stamps.component.html",
  styleUrls: ["./my-stamps.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class PassportMyStampsComponent {
    private bottomSheet: MatBottomSheet = inject(MatBottomSheet);
    private bottomSheetData: any = inject(MAT_BOTTOM_SHEET_DATA, { optional: true });
    private routeService = inject(ActivatedRoute);
    private passportService = inject(PassportService);
    private tools = inject(ToolsService);
    public translate = inject(TranslateService);
    public stampList = signal<StampProfile[]>([]);
    public isBottomSheet = signal<boolean>(false);
    public mapMarkers = signal([]);

    ngOnInit(){
      const id = this.routeService.snapshot.paramMap.get('id');
      const idRef = this.bottomSheetData?.idRef;
      this.isBottomSheet.set(!!idRef);

      const passportId = idRef ?? id;
      if (!passportId)
        return;

      // * MOCK METHODS * //
      //this.passportService.getMyStampsFake(passportId).subscribe((res: StampProfile[]) => {
      //  this.stampList.set(res);
      //})

      this.getApiData(passportId);
    }

    private async getApiData(passportId){
      await this.tools.waitUntilReady();
      
      this.passportService.getBadgesByPassportId(passportId).subscribe((res: any) => {
        if(!res) return;  
        
        const data = res.data;
        if (data === 0) return;

        this.stampList.set(data);
        this.setMapMarkerData(data);
      });
    }

    private setMapMarkerData(data){
      const markerData = data?.map(e => e.marker)?.filter(e => e)?.filter(e => e.location);
      this.mapMarkers.set(markerData);
    }

    public dismissBottomSheet(){
        this.bottomSheet.dismiss();
    }
}
